import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useLocales } from 'src/locales';
import PulseDot from 'src/components/pulse-dot';
import { useResponsiveConfig } from 'src/components/competitive-intelligence/utils/use-responsive-config';

type CompetitionEvolutionLevel = 'high' | 'active' | 'low' | string;

type Props = {
  level: CompetitionEvolutionLevel | null;
  brandDomain?: string | null;
  competitorDomain?: string | null;
  brandPresenceRate?: number | null;
  competitorPresenceRate?: number | null;
  isDemoBrand?: boolean;
  fullWidth?: boolean;
};


export default function CompetitionEvolutionCell({ level }: Props) {
  const { t } = useLocales();
  const responsiveConfig = useResponsiveConfig();
  // TODO: remove this, for development purposes
  if (level === null) {
    level = 'high';
  }

  // Color mapping: high -> red, active -> orange, low -> green
  const colorByLevel = React.useMemo(() => {
    if (level === 'high') return "#E34B4E";
    if (level === 'active') return "#FFA444";
    return "#14C779"; // low -> green
  }, [level]);

  const dotSize = 16;

  // Cette fonction traduit les 3 niveaux de concurrence en français
  const mapLevelToLabelTranslated = (level: CompetitionEvolutionLevel | null) => {
    switch (level) {
      case 'high':
        return t('dashboard.competitiveIntelligence.competitionEvolutionLevels.high');
      case 'active':
        return t('dashboard.competitiveIntelligence.competitionEvolutionLevels.active');
      case 'low':
        return t('dashboard.competitiveIntelligence.competitionEvolutionLevels.low');
      default:
        return level ?? '';
    }
  };


  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="body2" sx={{ minWidth: responsiveConfig.competitionEvolutionLabelMinWidth }}>
        {mapLevelToLabelTranslated(level)}
      </Typography>
      <PulseDot color={colorByLevel} size={dotSize} />
    </Stack>
  );
}

